import React from 'react';

import {Tag} from 'folder-items/FileConstants';
import NoteConstants from 'notebook/notes/NoteConstants';
import {PreviewProps} from 'notebook/notes/previews/PreviewMixin';
import usePreviewMixin from 'notebook/notes/previews/usePreviewMixin';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';

function renderAttr(name: string, value: string): JSX.Element {
  return (
    <div key={name} className="notePreview-bfiTag">
      <Row className="u-small-spacing-left">
        <Col sm={4}>
          <div className="u-faded">{name}</div>
        </Col>
        <Col sm={8}>{value}</Col>
      </Row>
    </div>
  );
}

export default function BasicFolderItemPreview(props: PreviewProps): JSX.Element {
  const {render} = usePreviewMixin({
    ...props,
    className: 'note-BasicFolderItem',
    noteType: NoteConstants.BASIC_FOLDER_ITEM,
    renderItem: () => (
      <div className="note-preview-body">
        {
          // @ts-expect-error(2339): Tags don't exist on all NotePartItems
          Array.from(props.item?.tags ?? []).map((tag: Tag) => renderAttr(tag.name, tag.value))
        }
      </div>
    ),
  });

  return render();
}
